var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { IsBoolean, IsEnum, IsNumber, IsOptional, IsPhoneNumber, IsString, } from 'class-validator';
import { TransformBoolean } from '../../../decorators';
import { Gender } from '../../../enums/common/gender.enum';
export class CreateD2CUserDto {
}
__decorate([
    IsNumber(),
    __metadata("design:type", Number)
], CreateD2CUserDto.prototype, "companyId", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "username", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "password", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateD2CUserDto.prototype, "name", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "nickname", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "profileImageURL", void 0);
__decorate([
    IsString(),
    __metadata("design:type", String)
], CreateD2CUserDto.prototype, "email", void 0);
__decorate([
    IsPhoneNumber('KR'),
    __metadata("design:type", String)
], CreateD2CUserDto.prototype, "phoneNumber", void 0);
__decorate([
    IsNumber(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "birthYear", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "birthday", void 0);
__decorate([
    IsEnum(Gender),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "gender", void 0);
__decorate([
    IsString(),
    IsOptional(),
    __metadata("design:type", Object)
], CreateD2CUserDto.prototype, "signUpSource", void 0);
__decorate([
    TransformBoolean(),
    IsBoolean(),
    IsOptional(),
    __metadata("design:type", Boolean)
], CreateD2CUserDto.prototype, "isMarketingAgreed", void 0);
